<template>
    <div class="d-flex align-items-center">
        <CContainer fluid>
            <CRow>
                <CCol md="3">
                    <CCard class="mx-2 mb-0">
                        <CCardBody class="p-4">
                            <div class="avatar-wrapper">
                                <span id="avatar" :style="bannerBgImage()" class="e-avatar e-avatar-xlarge e-avatar-circle" v-text="imageUrl ? '' : ''"></span>
                            </div>
                            <ejs-uploader ref="uploadObj" id='uploadAvatar' name="UploadFile" :asyncSettings="path" :uploading="addHeaders" :allowedExtensions="extensions" :success="onUploadSuccess"></ejs-uploader>
                            
                        </CCardBody>
                    </CCard>
                   
                            <div class="p-4">
                                <img v-if="$store.state.avatarUrl" :src="$store.state.avatarUrl"
                                     class="c-avatar-i" width="160" height="160" />
                                <img v-else src="/avatarpl.jpg"
                                     class="c-avatar-img" />
                            </div>
                </CCol>
                <CCol md="4">
                    <CCard class="mx-2 mb-0">
                        <CCardBody class="p-4">
                                <h1>Profile</h1>
                                <div class='wrap'>
                                    <div id='input-container'>
                                        <ejs-textbox v-model="user.firstName" floatLabelType="Auto" :disabled="true" type="text" placeholder="First name" />
                                        <ejs-textbox  v-model="user.lastName" floatLabelType="Auto" :disabled="true" type="text" placeholder="Last name" />
                                        <ejs-textbox  v-model="user.email" floatLabelType="Auto" :disabled="true" name='input' type="email" placeholder="Email" />
                                        <!--<input class="e-input" v-model="user.clientName" name='input' type="text" readonly placeholder="Client" />-->
                                       
                                    </div>
                                </div>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    </div>
</template>

<script>
    import { UploaderPlugin, TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
    import Vue from "vue";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import apis from '../../common/network'
    import SyncHelper from '../../common/syncfusion';
    import urls from '../../common/urls';
    import authToken from '../../common/authToken';

    Vue.use(ButtonPlugin); 
    Vue.use(UploaderPlugin);
    Vue.use(TextBoxPlugin);

    export default {
        name: 'Profile',
        data: function () {
            return {
                user: {},
                path: {
                    saveUrl: `${urls.apiBaseUrl}upload/avatar?userId=${this.$store.state.loggedInUserId}`,
                },
                imageUrl: this.$store.state.avatarUrl,
                extensions: '.jpg,.png'
            }
        },
        created() {
            apis.protectedApi(`utils/userData/${this.$store.state.loggedInUserId}`)
                .then(response => {
                    this.user = response.data;
                 }).catch(e => {
                    console.log('error', e);
                });
        },
        methods: {
            //reset: function () {
            //    apis.navigateToResetLink(this.$store.state.loggedInUserEmail, this.$store.state.loggedInUserEmail);
            //},
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onUploadSuccess: function (args) {
                var response = JSON.parse(args.e.currentTarget.response);
                if (response.imageUrl) {
                    this.imageUrl = null;
                    localStorage.setItem('avatarUrl', response.imageUrl);
                    this.$store.commit('setAvatarUrl', response.imageUrl);
                    this.imageUrl = response.imageUrl;
                    this.bannerBgImage();
                }
            },
            bannerBgImage() {                
                return 'background-image: url("' + this.imageUrl + '")';
            }
        }

    }
</script>

<style scoped>

    #avatar {
        margin-bottom: 10px;
    }

    .resetPass {
        text-align: left;
    }

    .wrap {
        box-sizing: border-box;
        margin: 0 auto;
        padding: 20px 10px;
        width: auto;
    }

    .avatar-wrapper {
        text-align: center;
    }

    .e-input {
        margin: 30px 0;
        font-size: 18px;
    }

    #input-container .e-input-group {
        margin: 30px 0;
    }

    .e-input-group-icon:before {
        font-family: e-icons;
    }

    .e-input-group .e-input-group-icon.e-input-popup-date {
        font-size: 16px;
    }

    .e-input-group.e-small .e-input-group-icon.e-input-popup-date {
        font-size: 14px;
    }

    .e-input-group-icon.e-input-popup-date:before {
        content: "\e901";
    }

    #chgPass {
        padding: 0px;
    }

    .e-control .e-file-select,
    .e-control .e-file-drop {
        display: none !important;
    }

</style>